import { ModelSchema } from "simple-schema-model-validator";
import { isValidDate, validateEmail, validatePhone, validateRutChilean } from "src/shared/global/helpers";

export class PatientSchema extends ModelSchema {
    constructor () {
        const schemaModel = {
            "uswRut": {
                "alias": "Rut", 
                "type": "string",
                "required": true,
                "validate": function(value) {
                    if(validateRutChilean(value).ok === false) {
                        return {
                            ok: false,
                            message: "El Rut es incorrecto"
                        }
                    }
                    
                    return {
                        ok: true
                    }
                }
            },
            "uswEmail": {
                "alias": "Correo electrónico",
                "type": "string",
                "required": true,
                "validate": function(value) {
                    return validateEmail(value);
                }
            },
            "uswFonoMovil": {
                "alias": "Teléfono móvil",
                "type": "string",
                "required": false,
                "validate": function (value) {
                    return validatePhone(value);
                },
                "defaultValue": null
            },
            "uswCodFonoFijo1": {
                "alias": "Teléfono fijo",
                "type": "string",
                "required": false,
                "defaultValue": null
            },
            "uswFonoFijo1": {
                "alias": "Teléfono fijo",
                "type": "string",
                "required": false,
                "validate": function (value) {
                    return validatePhone(value);
                },
                "defaultValue": null
            },
            "uswNombres": {
                "alias": "Nombres",
                "type": "string",
                "required": true
            },
            "uswApePat": {
                "alias": "Apellido paterno",
                "type": "string",
                "required": true
            },
            "uswApeMat": {
                "alias": "Apellido materno",
                "type": "string",
                "required": false,
                "defaultValue": null
            },
            "fechaNac": {
                "alias": "Fecha nacimiento",
                "type": "string",
                "required": true,
                "validate": function (value) {
                    const [year, month, day] = value.split("-");
                    const yearCurrent = new Date().getFullYear();

                    if(new Date(`${year}/${month}/${day}`) > new Date()) {
                        return {
                            ok: false,
                            message: 'no puede superar a la fecha actual'
                        }
                    }

                    if((Number(year) < 1900 || year > yearCurrent)) {
                        return {
                            ok: false,
                            message: 'es incorrecta'
                        }
                    }

                    if(!isValidDate(value)) {
                        return {
                            ok: false,
                            message: 'es incorrecta'
                        }
                    } else {
                        return {
                            ok: true
                        }
                    }
                }
            },
            "idgGenero": {
                "alias": "Género",
                "type": "number",
                "required": false,
                "defaultValue": null
            },
            "isaCodigo": {
                "alias": "Previsión",
                "type": "number",
                "required": null,
                "defaultValue": null
            },
            // "uswClave": {
            //     "alias": "Contraseña",
            //     "type": "string",
            //     "required": true
            // },
            // "uswRepetirClave": {
            //     "alias": "Contraseña",
            //     "type": "string",
            //     "required": true
            // }
        }

        super(schemaModel);
    }
}